import { QueovalDik, QueovalBase, QueovalDate, GridParamGeneric } from '../global/class.global';
import {Select} from '../utilities';

export class AcompteModel extends QueovalBase {
  public Acompte: AcompteData;
  public ListAcomptes: Array<AcompteData>;
  public ListModeReglements: Array<QueovalDik>;
  public ListEcrituresBq: Array<QueovalDik>;
  public ListEntites: Array<QueovalDik>;
  public ListGroupes: Array<QueovalDik>;
  public ListAcomptesGeneric: Array<GridParamGeneric>;
  public ListeTypePeriodicite: Array<Select>;
  constructor() {
    super();
    this.Acompte = new AcompteData();
    this.ListAcomptes = new Array<AcompteData>();
    this.ListModeReglements = new Array<QueovalDik>();
    this.ListEcrituresBq = new Array<QueovalDik>();
    this.ListEntites = new Array<QueovalDik>();
    this.ListGroupes = new Array<QueovalDik>();
    this.ListAcomptesGeneric = [];
    this.ListeTypePeriodicite = new Array<Select>();
  }
}

export class AcompteData {
  public StrIdent: string;
  public Montant: number | null; 
  public Date: QueovalDate;
  public Libelle: string;
  public ModeReglement: string;
  public StrNumFolio: string;
  public StrIdDonneurOrdre: string;
  public StrNameDonneurOrdre: string;
  public StrIdFinanceur: string;
  public StrNameFinanceur: string;
  //public StrSelectedStage: string;
  //public StrSelectedMission: string;
  //public StrSelectedPrestation: string;
  public StrSelectedObjetFacturable: string;
  public StrSelectedEntite: string;
  public StrSelectedGroupe: string;
  public StrSelectedBq: string;
  public WithEcriture: boolean;
  public NbreEcheance: number;
  public Periodicite: Select;
  public Echeanciers: Array<EcheancierPrelevement>;
  public MontantTotalEcheance: number;
  constructor() {
    this.WithEcriture = true;
    this.Date = new QueovalDate();
    this.NbreEcheance = 1;
    this.Periodicite = new Select();
    this.Echeanciers = new Array<EcheancierPrelevement>();
  }
}

export class EcheancierPrelevement {
  public Ident: string;
  public Libelle: string;
  public TypeReglement: string;
  public Date: QueovalDate;
  public Montant: number;
  public IdBanque: string;
  public IdEntite: string;
  public IdGroupe: string;
  public InfoFichierSepa: string;
  public ReadOnly: boolean;
  public InfoExportCompta: string;
  public IsExportCompta: boolean;
  public Reprelever: boolean;  
  public Deleted: boolean;  
}
